export default {
  methods: {
    updateDates(start, end) {
      this.range.start = start;
      this.range.end = end;
    },
  },
};
